export class userUpdateRequest {
    Id?: number;
    username:string;
    password:string;
    email:string;
    isActive: boolean;
    createdUser:number;
    updatedUser: number | null;
    versionFlag: number;
  
}
export class IdRequest {
    Id:number;
    updatedUser: number | null;
    versionFlag: number;
  }
  export class userStatusUpdateRequest{
    Id:number;
    isActive:boolean;
  }


